<!-- NAVBAR START -->
<nav class="navbar navbar-expand-lg py-lg-3 navbar-dark">
    <div class="container">
      <!-- logo -->
      <a href="landing.html" class="navbar-brand mr-lg-5">
        <img
        src="../../../assets/images/logo-white.svg"
          alt=""
          class="logo-dark"
          height="30"
        />
      </a>

      <button
        class="navbar-toggler"
        type="button"
        data-toggle="collapse"
        data-target="#navbarNavDropdown"
        aria-controls="navbarNavDropdown"
        aria-expanded="false"
        aria-label="Toggle navigation"
      >
        <span class="mdi mdi-menu"></span>
      </button>

      <!-- menus -->
      <div class="collapse navbar-collapse" id="navbarNavDropdown">
        <!-- left menu -->
        <ul class="navbar-nav mr-auto align-items-center">
            <li class="nav-item mx-lg-1">
              <a  class="nav-link "  [routerLink]="['/landing']" routerLinkActive="active" >Home</a>
            </li>
            <li class="nav-item mx-lg-1">
              <a class="nav-link" [routerLink]="['/features']" routerLinkActive="active">Features</a>
            </li>
            <li class="nav-item mx-lg-1">
              <a class="nav-link" [routerLink]="['/pricing']" routerLinkActive="active">Pricing</a>
            </li>
            <li class="nav-item mx-lg-1">
              <a class="nav-link" [routerLink]="['/faqs']" routerLinkActive="active">FAQs</a>
            </li>
            <li class="nav-item mx-lg-1">
              <a class="nav-link" [routerLink]="['/partners']" routerLinkActive="active">Partners</a>
            </li>
            <li class="nav-item mx-lg-1">
              <a class="nav-link" [routerLink]="['/contact']" routerLinkActive="active">Contact</a>
            </li>
          </ul>
  
          <!-- right menu -->
          <ul class="navbar-nav ml-auto align-items-center">
            <li class="nav-item mx-lg-1">
              <a class="nav-link" [routerLink]="['/login']" routerLinkActive="active">Sign Up</a>
            </li>
            <li class="nav-item mx-lg-1">
              <a class="nav-link" [routerLink]="['/login']" routerLinkActive="active">Sign In</a>
            </li>
          </ul>
      </div>
    </div>
  </nav>
  <!-- NAVBAR END -->

  <!-- START HERO -->
  <section class="hero-section">
    <!-- Pricing Title-->
    <div class="text-center text-white">
      <h3 class="mb-2">Our Plans and Pricing</h3>
      <p class="text-white w-50 m-auto">
        We have plans and prices that fit your business perfectly. Make your
        client site a success with our products.
      </p>
    </div>
  </section>
  <section class="py5">
    <div class="container-fluid">
      <div class="row justify-content-center">
        <div class="col-xl-10">
          <!-- Plans -->
          <div class="row mt-sm-5 mt-3 mb-3">
            <div class="col-md-4">
              <div class="card card-pricing">
                <div class="card-body text-center">
                  <p
                    class="card-pricing-plan-name font-weight-bold text-uppercase"
                  >
                    Professional Pack
                  </p>
                  <span
                    class="card-pricing-icon dripicons-user text-primary"
                  ></span>
                  <h2 class="card-pricing-price">$19 <span>/ Month</span></h2>
                  <ul class="card-pricing-features">
                    <li>10 GB Storage</li>
                    <li>500 GB Bandwidth</li>
                    <li>No Domain</li>
                    <li>1 User</li>
                    <li>Email Support</li>
                    <li>24x7 Support</li>
                  </ul>
                  <button class="btn btn-primary mt-4 mb-2 btn-rounded">
                    Choose Plan
                  </button>
                </div>
              </div>
              <!-- end Pricing_card -->
            </div>
            <!-- end col -->

            <div class="col-md-4">
              <div class="card card-pricing card-pricing-recommended">
                <div class="card-body text-center">
                  <div class="card-pricing-plan-tag">Recommended</div>
                  <p
                    class="card-pricing-plan-name font-weight-bold text-uppercase"
                  >
                    Business Pack
                  </p>
                  <span
                    class="card-pricing-icon dripicons-briefcase text-primary"
                  ></span>
                  <h2 class="card-pricing-price">$29 <span>/ Month</span></h2>
                  <ul class="card-pricing-features">
                    <li>50 GB Storage</li>
                    <li>900 GB Bandwidth</li>
                    <li>2 Domain</li>
                    <li>10 User</li>
                    <li>Email Support</li>
                    <li>24x7 Support</li>
                  </ul>
                  <button class="btn btn-primary mt-4 mb-2 btn-rounded">
                    Choose Plan
                  </button>
                </div>
              </div>
              <!-- end Pricing_card -->
            </div>
            <!-- end col -->

            <div class="col-md-4">
              <div class="card card-pricing">
                <div class="card-body text-center">
                  <p
                    class="card-pricing-plan-name font-weight-bold text-uppercase"
                  >
                    Enterprise Pack
                  </p>
                  <span
                    class="card-pricing-icon dripicons-store text-primary"
                  ></span>
                  <h2 class="card-pricing-price">$39 <span>/ Month</span></h2>
                  <ul class="card-pricing-features">
                    <li>100 GB Storege</li>
                    <li>Unlimited Bandwidth</li>
                    <li>10 Domain</li>
                    <li>Unlimited User</li>
                    <li>Email Support</li>
                    <li>24x7 Support</li>
                  </ul>
                  <button class="btn btn-primary mt-4 mb-2 btn-rounded">
                    Choose Plan
                  </button>
                </div>
              </div>
              <!-- end Pricing_card -->
            </div>
            <!-- end col -->
          </div>
          <!-- end row -->
        </div>
        <!-- end col-->
      </div>
      <!-- end row -->
    </div>
  </section>
  <!-- END HERO -->

  <!-- START FOOTER -->
  <footer class="bg-dark py-5">
    <div class="container">
      <div class="row">
        <div class="col-lg-6">
          <img
          src="../../../assets/images/logo-white.svg"
            alt=""
            class="logo-dark"
            height="30"
          />
          <p class="text-white-50 mt-4">
            Hyper makes it easier to build better websites with <br />
            great speed. Save hundreds of hours of design <br />
            and development by using it.
          </p>

          <ul class="social-list list-inline mt-3">
            <li class="list-inline-item text-center">
              <a
                href="javascript: void(0);"
                class="social-list-item border-primary text-primary"
                ><span class="mdi mdi-facebook"></span
              ></a>
            </li>
            <li class="list-inline-item text-center">
              <a
                href="javascript: void(0);"
                class="social-list-item border-danger text-danger"
                ><span class="mdi mdi-google"></span
              ></a>
            </li>
            <li class="list-inline-item text-center">
              <a
                href="javascript: void(0);"
                class="social-list-item border-info text-info"
                ><span class="mdi mdi-twitter"></span
              ></a>
            </li>
            <li class="list-inline-item text-center">
              <a
                href="javascript: void(0);"
                class="social-list-item border-secondary text-secondary"
                ><span class="mdi mdi-github-circle"></span
              ></a>
            </li>
          </ul>
        </div>

        <div class="col-lg-2 mt-3 mt-lg-0">
          <h5 class="text-white">Company</h5>

          <ul class="list-unstyled pl-0 mb-0 mt-3">
            <li class="mt-2">
              <a href="javascript: void(0);" class="text-white-50"
                >About Us</a
              >
            </li>
            <li class="mt-2">
              <a href="javascript: void(0);" class="text-white-50"
                >Documentation</a
              >
            </li>
            <li class="mt-2">
              <a href="javascript: void(0);" class="text-white-50">Blog</a>
            </li>
            <li class="mt-2">
              <a href="javascript: void(0);" class="text-white-50"
                >Affiliate Program</a
              >
            </li>
          </ul>
        </div>

        <div class="col-lg-2 mt-3 mt-lg-0">
          <h5 class="text-white">Apps</h5>

          <ul class="list-unstyled pl-0 mb-0 mt-3">
            <li class="mt-2">
              <a href="javascript: void(0);" class="text-white-50"
                >Ecommerce Pages</a
              >
            </li>
            <li class="mt-2">
              <a href="javascript: void(0);" class="text-white-50">Email</a>
            </li>
            <li class="mt-2">
              <a href="javascript: void(0);" class="text-white-50"
                >Social Feed</a
              >
            </li>
            <li class="mt-2">
              <a href="javascript: void(0);" class="text-white-50"
                >Projects</a
              >
            </li>
            <li class="mt-2">
              <a href="javascript: void(0);" class="text-white-50"
                >Tasks Management</a
              >
            </li>
          </ul>
        </div>

        <div class="col-lg-2 mt-3 mt-lg-0">
          <h5 class="text-white">Discover</h5>

          <ul class="list-unstyled pl-0 mb-0 mt-3">
            <li class="mt-2">
              <a href="javascript: void(0);" class="text-white-50"
                >Help Center</a
              >
            </li>
            <li class="mt-2">
              <a href="javascript: void(0);" class="text-white-50"
                >Our Products</a
              >
            </li>
            <li class="mt-2">
              <a href="privacy.html" class="text-white-50">Privacy</a>
            </li>
          </ul>
        </div>
      </div>

      <div class="row">
        <div class="col-lg-12">
          <div class="mt-5">
            <p class="text-white-50 mt-4 text-center mb-0">
              © 2018 - 2020 Hyper. Design and coded by Coderthemes
            </p>
          </div>
        </div>
      </div>
    </div>
  </footer>
  <!-- END FOOTER -->
